import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import {
  fetchPatientInboundFaxes as fetchPatientInboundFaxesRequest,
  fetchPatientOutboundFaxes as fetchPatientOutboundFaxesRequest,
} from '@lotushealth/lotushealth_js_sdk/endpoints';
import type {
  PatientInboundFaxesResponseT,
  PatientInboundFaxT,
  PatientOutboundFaxesResponseT,
  PatientOutboundFaxT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPatientOutboundFaxes(
  userId: string,
  signal?: AbortSignal
): Promise<PatientOutboundFaxT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchPatientOutboundFaxesRequest(userId, config);
  const parsed = lotusHealthZod.fetchPatientOutboundFaxesResponse.parse(
    response.data
  ) as PatientOutboundFaxesResponseT;
  return parsed.faxes;
}

export async function fetchPatientInboundFaxes(
  userId: string,
  signal?: AbortSignal
): Promise<PatientInboundFaxT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchPatientInboundFaxesRequest(userId, config);
  const parsed = lotusHealthZod.fetchPatientInboundFaxesResponse.parse(
    response.data
  ) as PatientInboundFaxesResponseT;
  return parsed.faxes;
}
